import { DatePipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { FormControl } from '@angular/forms';
import { BookingConfigService } from '../../../services/booking-config.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../../../app/services/auth.service';
import { WelcomeComponent } from '../../../components/welcome/welcome.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-advanced-widget',
  templateUrl: './advanced-widget.component.html',
  styleUrl: './advanced-widget.component.css',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService]
})
export class AdvancedWidgetComponent {
  site: string = '';
  activeTab: string = "book";

  arrivalFlight: any;
  departureFlight: any;

  arrivalFlightDate: any;
  departureFlightDate: any;

  hotelArrivalDatetime: any;
  hotelDepartureDatetime: any;

  parkingArrivalTime: any;
  parkingDepartureTime: any;

  arrivalHotel: any;
  departureHotel: any;

  isArrivalHotel: any;
  isDepartureHotel: any;

  parkingStartTime: any;
  parkingEndTime: any;

  selectType: string = '';
  private _organization: string = '';
  discountCodeControl = new FormControl('');
  flightTimeWarning = false;
  org: string = 'flygets';
  currentLang: string = 'sv';

  constructor(
    private router: Router,
    private _formService: FormService,
    private _datePipe: DatePipe,
    private route: ActivatedRoute,
    private bookingConfigService: BookingConfigService,
    private authService: AuthService,
    private dialog: MatDialog,
    private translate: TranslocoService

  ) {
    this.site = "flygets";
    this._formService.initForm(this.site);
    this.currentLang = this.translate.getActiveLang();
  }

  ngOnInit(): void {

    // localStorage.setItem('navigation_organization', 'A848CCD3-FD8D-4035-925E-571EBB4E93E8');
    // localStorage.setItem('selectedOrganization', 'flygets');

    this.route.queryParams.subscribe(params => {
      let orgId = params['orgId'] || 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
      switch (orgId) {
        case 'A848CCD3-FD8D-4035-925E-571EBB4E93E8':
          this.org = "flygets";
          localStorage.setItem('navigation_organization', 'A848CCD3-FD8D-4035-925E-571EBB4E93E8');
          localStorage.setItem('selectedOrganization', 'flygets');
          break;
        case '3868EF69-054C-40BD-93AE-85CF08E4C71F':
          this.org = "nazar";
          localStorage.setItem('navigation_organization', '3868EF69-054C-40BD-93AE-85CF08E4C71F');
          localStorage.setItem('selectedOrganization', 'nazar');
          break;
        case '2868EF69-054C-40BD-93AE-85CF08E4C71F':
          this.org = "tui";
          localStorage.setItem('navigation_organization', '2868EF69-054C-40BD-93AE-85CF08E4C71F');
          localStorage.setItem('selectedOrganization', 'tui');
          break;
        default:
          this.org = "flygets";
          localStorage.setItem('navigation_organization', 'A848CCD3-FD8D-4035-925E-571EBB4E93E8');
          localStorage.setItem('selectedOrganization', 'flygets');
      }
    });

    const search = this._formService.getForm().get('search');
    const flights = this._formService.getForm().get('flights');
    const hotels = this._formService.getForm().get('hotels');

    flights.controls.arrivalFlight.valueChanges.subscribe((value: any) => {
      this.arrivalFlight = value;
    });
    flights.controls.departureFlight.valueChanges.subscribe((value: any) => {
      this.departureFlight = value;
    });

    search.controls.arrivalFlightDate.valueChanges.subscribe((value: any) => {
      this.arrivalFlightDate = value;
    });
    search.controls.departureFlightDate.valueChanges.subscribe((value: any) => {
      this.departureFlightDate = value;
    });

    search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.parkingDepartureTime = value;
    });
    search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.parkingArrivalTime = value;
    });

    hotels.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.hotelArrivalDatetime = value;

    });
    hotels.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.hotelDepartureDatetime = value;
    });

    hotels.controls.arrivalHotel.valueChanges.subscribe((value: any) => {
      this.arrivalHotel = value;
    });
    hotels.controls.departureHotel.valueChanges.subscribe((value: any) => {
      this.departureHotel = value;
    });

    search.controls.isArrivalHotel.valueChanges.subscribe((value: any) => {
      this.isArrivalHotel = value;
    });
    search.controls.isDepartureHotel.valueChanges.subscribe((value: any) => {
      this.isDepartureHotel = value;
    });
  }


  get isContinueButtonEnabled(): boolean {
    let isArrivalComplete = false;
    let isDepartureComplete = false;

    if (this.isArrivalHotel) {
      isArrivalComplete = this.arrivalHotel && this.hotelArrivalDatetime;
    } else {
      isArrivalComplete = this.arrivalFlight && this.parkingDepartureTime;
    }

    if (this.isDepartureHotel) {
      isDepartureComplete = this.departureHotel && this.hotelDepartureDatetime;
    } else {
      isDepartureComplete = this.departureFlight && this.parkingArrivalTime;
    }

    if (this.arrivalFlight && this.departureFlight) {

      const depTime = new Date(this.departureFlight?.departureTime?.scheduled)?.getTime();
      const arrTime = new Date(this.arrivalFlight?.arrivalTime?.scheduled)?.getTime();

      if (arrTime < depTime) {
        this.flightTimeWarning = true;
      } else {
        this.flightTimeWarning = false;
      }
    }

    return isArrivalComplete && isDepartureComplete && this.flightTimeWarning == false;
  }

  goToBookingForm() {

    this.navigateToBooking();

    // if (this.authService.loggedIn()) {
    //   this.navigateToBooking();
    // } else {
    //   const dialogRef = this.dialog.open(WelcomeComponent, {
    //     width: '500px',
    //     disableClose: false,
    //     panelClass: 'welcome-dialog'
    //   });

    //   dialogRef.afterClosed().subscribe(() => {
    //     this.navigateToBooking();
    //   });
    // }
  }

  navigateToBooking() {

    const hotels = this._formService.getForm().get('hotels');
    const flights = this._formService.getForm().get('flights');
    const search = this._formService.getForm().get('search');

    let parking_start = this._formService.searchStartDate;
    let parking_end = this._formService.searchEndDate;

    let arrival_flight = this._formService.selectedArrivalFlight;
    let departure_flight = this._formService.selectedDepartureFlight.getValue();

    parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
    parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');

    if (this._formService.getForm().get('search').controls.isArrivalHotel.value) {
      parking_end = this._formService.getForm().get('hotels').controls.arrivalDatetime.value;
      parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');
      arrival_flight = null;
    } else {
      hotels.controls.arrivalDatetime = null;
      hotels.controls.arrivalHotel = null;
      this._formService.arrivalHotel = null;
    }
    if (this._formService.getForm().get('search').controls.isDepartureHotel.value) {
      parking_start = this._formService.getForm().get('hotels').controls.departureDatetime.value;
      parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
      departure_flight = null;
    } else {
      hotels.controls.departureDatetime = null;
      hotels.controls.departureHotel = null;
      this._formService.departureHotel = null;

    }
    let departure_hotel = this._formService.departureHotel || null;
    let arrival_hotel = this._formService.arrivalHotel || null;

    const getValString = (val: any) => {
      if (!val) return null;
      if (val instanceof Date) return this._datePipe.transform(val, 'yyyy-MM-dd HH:mm');
      if (typeof val === 'string') return val;
      return val;
    };

    let searchData = {
      //arrival
      arrivalFlightDate: getValString(search.controls.arrivalFlightDate?.value),
      arrivalFlight: flights.controls.arrivalFlight?.value,
      arrivalDatetime: getValString(search.controls.arrivalDatetime?.value),

      arrivalHotel: hotels.controls.arrivalHotel?.value,
      hotelArrivalDate: getValString(hotels.controls.arrivalDatetime?.value),
      hotelArrivalDatetime: getValString(hotels.controls.arrivalDatetime?.value),

      //departure
      hotelDepartureDate: getValString(hotels.controls.departureDatetime?.value),
      departureHotel: hotels.controls.departureHotel?.value,
      hotelDepartureDatetime: getValString(hotels.controls.departureDatetime?.value),

      departureFlight: flights.controls.departureFlight?.value,
      departureFlightDate: getValString(search.controls.departureFlightDate?.value),
      departureDatetime: getValString(search.controls.departureDatetime?.value),
    }
    let queryParams: any = {
      parking_start: parking_start || undefined,
      parking_end: parking_end || undefined,
    };

    if (this.discountCodeControl.value.length) {
      queryParams['discount_code'] = this.discountCodeControl.value ?? 'NONE';
    }

    // Store data in sessionStorage for new tab
    const bookingData = {
      arrival_flight,
      departure_flight,
      departure_hotel,
      arrival_hotel,
      searchData,
      org: this._organization || this.site
    };
    sessionStorage.setItem('bookingData', JSON.stringify(bookingData));

    const urlTree = this.router.createUrlTree(
      ['parkifly', this.org, 'booking', {
        parking_start: parking_start,
        parking_end: parking_end,
        discount_code: this.discountCodeControl.value ?? 'NONE',
        booking_data: JSON.stringify(bookingData)
      }]
    );

    const relativeUrl = this.router.serializeUrl(urlTree);
    const fullUrl = window.location.origin + relativeUrl;
    window.open(fullUrl, '_blank');

  }

  setLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.setActiveLang(lang);
  }

}
